import { AuthIllustrationLogin } from "./AuthIllustration";
import { AuthIllustrationSignUp } from "./AuthIllustration";

/** Login side: card LEFT, content RIGHT. Fits in viewport (no scroll). */
export function AuthSideContentLogin() {
  return (
    <div className="flex flex-col gap-3 sm:gap-4 text-left min-h-0 max-h-full overflow-hidden min-w-0">
      <p className="text-xs sm:text-sm font-medium text-primary uppercase tracking-wide flex-shrink-0">Welcome back</p>
      <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold tracking-tight text-foreground leading-tight flex-shrink-0 break-words">
        Pick up where your turnovers left off.
      </h1>
      <p className="text-sm text-muted-foreground flex-shrink-0 break-words">
        Sign in to manage schedules, delegate tasks, and keep every property running smoothly.
      </p>
      <ul className="space-y-1 text-sm text-muted-foreground flex-shrink-0 break-words">
        <li className="flex items-start gap-2">
          <span className="text-primary mt-0.5 shrink-0">•</span>
          <span>Real-time task progress, photos, and issue tracking</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-primary mt-0.5">•</span>
          <span>Assign cleaners and team members in seconds</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-primary mt-0.5">•</span>
          <span>Inventory + maintenance checks built into every turnover</span>
        </li>
      </ul>
      <p className="text-xs text-muted-foreground italic flex-shrink-0">
        Tip: Team members can join from an invite link—no setup required.
      </p>
      <div className="min-h-0 flex-1 flex items-end justify-center pt-2">
        <AuthIllustrationLogin />
      </div>
    </div>
  );
}

/** Sign Up side: card RIGHT, content LEFT. Fits in viewport (no scroll). */
export function AuthSideContentSignUp() {
  return (
    <div className="flex flex-col gap-3 sm:gap-4 text-left min-h-0 max-h-full overflow-hidden min-w-0">
      <p className="text-xs sm:text-sm font-medium text-primary uppercase tracking-wide flex-shrink-0">Get started in minutes</p>
      <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold tracking-tight text-foreground leading-tight flex-shrink-0 break-words">
        Build a cleaner-ready workflow in one setup.
      </h1>
      <p className="text-sm text-muted-foreground flex-shrink-0 break-words">
        Create your account to auto-create turnovers from bookings, standardize checklists, and invite your team instantly.
      </p>
      <ul className="space-y-1 text-sm text-muted-foreground flex-shrink-0 break-words">
        <li className="flex items-start gap-2">
          <span className="text-primary mt-0.5 shrink-0">•</span>
          <span>Calendar sync → turnovers auto-created</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-primary mt-0.5">•</span>
          <span>Room-by-room checklists with photo requirements</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-primary mt-0.5">•</span>
          <span>Invite cleaners and collaborators, then delegate from inside the property</span>
        </li>
      </ul>
      <p className="text-xs text-muted-foreground flex-shrink-0">
        No app download for cleaners. Mobile-first dashboard included.
      </p>
      <div className="min-h-0 flex-1 flex items-end justify-center pt-2">
        <AuthIllustrationSignUp />
      </div>
    </div>
  );
}
